// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "rescript/lib/es6/caml.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as Region from "common/src/Region.bs.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Axis from "@visx/axis";
import * as Grid from "@visx/grid";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as Scale from "@visx/scale";
import * as LpChartUtils from "common/src/LpChartUtils.bs.js";
import * as Caml_splice_call from "rescript/lib/es6/caml_splice_call.js";
import * as WrappedSectionHeader from "./WrappedSectionHeader.bs.js";

function WrappedTimeStats$HourStats(Props) {
  var hourStats = Props.hourStats;
  var totGames = Props.totGames;
  var hourStats$1 = React.useMemo((function () {
          var data = Belt_Array.make(24, [
                0,
                0
              ]);
          var d = new Date();
          var offset = (d.getTimezoneOffset() | 0) / -60 | 0;
          Belt_Array.forEachWithIndex(hourStats, (function (idx, v) {
                  Belt_Array.set(data, ((24 + idx | 0) + offset | 0) % 24, v);
                  
                }));
          return data;
        }), [hourStats]);
  var screenSize = ScreenAtom.use(undefined);
  var match = React.useState(function () {
        
      });
  var setHoverIdx = match[1];
  var hoverIdx = match[0];
  var minCount = Caml.caml_int_min(Caml.caml_int_max(totGames / 100 | 0, 2), 5);
  var minPlace = Caml_splice_call.spliceApply(Math.min, [Belt_Array.map(Belt_Array.keep(hourStats$1, (function (param) {
                    return param[0] >= minCount;
                  })), (function (prim) {
                return prim[1];
              }))]);
  var maxPlace = Caml_splice_call.spliceApply(Math.max, [Belt_Array.map(Belt_Array.keep(hourStats$1, (function (param) {
                    return param[0] >= minCount;
                  })), (function (prim) {
                return prim[1];
              }))]);
  var xScale = Scale.scaleLinear({
        domain: [
          -0.5,
          23.5
        ],
        range: [
          0,
          Global.f(300)
        ]
      });
  var xScaleRev = Scale.scaleLinear({
        domain: [
          0,
          Global.f(300)
        ],
        range: [
          -0.5,
          23.5
        ]
      });
  var yScale = Scale.scaleLinear({
        domain: [
          minPlace,
          maxPlace + (maxPlace - minPlace) / 10
        ],
        range: [
          0,
          Global.f(200)
        ]
      });
  var tmp;
  if (hoverIdx !== undefined) {
    var match$1 = Belt_Array.getExn(hourStats$1, hoverIdx);
    var count = match$1[0];
    tmp = React.createElement("div", {
          className: "absolute top-0 p-3 bg-bg0 rounded text-sm",
          style: Global.s({
                left: Global.toFixed(undefined, Caml.caml_float_min(250, -15 + Curry._1(xScale, Global.f(hoverIdx)))) + "px"
              })
        }, React.createElement("div", undefined, "Games: " + String(count)), React.createElement("div", undefined, "Place: " + (
              count === 0 ? "" : Global.toFixed(undefined, match$1[1])
            )));
  } else {
    tmp = null;
  }
  return React.createElement("div", {
              className: "flex flex-col items-center"
            }, React.createElement("div", undefined, "Placement by hour of the day"), React.createElement("div", {
                  className: "relative pr-6"
                }, React.createElement("svg", {
                      height: "240",
                      width: "340",
                      onMouseLeave: (function (param) {
                          return Curry._1(setHoverIdx, (function (param) {
                                        
                                      }));
                        }),
                      onMouseMove: (function (e) {
                          var left = e.nativeEvent.offsetX - 35 | 0;
                          var idx = Caml.caml_int_min(Caml.caml_int_max(Math.round(Curry._1(xScaleRev, Global.f(left))) | 0, 0), hourStats$1.length - 1 | 0);
                          return Curry._1(setHoverIdx, (function (param) {
                                        return idx;
                                      }));
                        })
                    }, React.createElement("g", {
                          transform: "translate(35, 10)"
                        }, React.createElement(Grid.Grid, {
                              top: 0,
                              left: 0,
                              xScale: xScale,
                              yScale: yScale,
                              stroke: "rgba(255, 255, 255, 0.24)",
                              width: 300,
                              height: 200,
                              numTicksRows: 5,
                              numTicksColumns: 8
                            }), React.createElement(Axis.AxisLeft, {
                              top: 0,
                              left: 0,
                              scale: yScale,
                              numTicks: 5,
                              stroke: "white",
                              tickStroke: "white",
                              tickLabelProps: (function (param) {
                                  return LpChartUtils.tickLabelPropsLeftBase(screenSize, param);
                                })
                            }), React.createElement(Axis.AxisBottom, {
                              top: 200,
                              left: 0,
                              scale: xScale,
                              numTicks: 8,
                              stroke: "white",
                              tickValues: Belt_Array.map(Belt_Array.range(0, 11), (function (x) {
                                      return Global.f((x << 1));
                                    })),
                              tickStroke: "white",
                              tickLabelProps: (function (param) {
                                  return LpChartUtils.tickLabelPropsBottom(screenSize, param);
                                })
                            }), Belt_Array.mapWithIndex(hourStats$1, (function (idx, param) {
                                if (param[0] < minCount) {
                                  return React.createElement("g", {
                                              key: String(idx)
                                            });
                                }
                                var place = param[1];
                                return React.createElement("rect", {
                                            key: String(idx),
                                            height: Global.toFixed(undefined, Global.f(200) - Curry._1(yScale, place)),
                                            width: "8",
                                            fill: Caml_obj.caml_equal(hoverIdx, idx) ? "var(--secondary-9)" : "var(--primary-10)",
                                            x: Global.toFixed(undefined, Curry._1(xScale, Global.f(idx)) - 4),
                                            y: Global.toFixed(undefined, Curry._1(yScale, place))
                                          });
                              })))), tmp), React.createElement("div", {
                  className: "text-sm text-white2"
                }, "Current timezone"));
}

var HourStats = {
  make: WrappedTimeStats$HourStats
};

function WrappedTimeStats$DowStats(Props) {
  var dowStats = Props.dowStats;
  var totGames = Props.totGames;
  var region = Props.region;
  var screenSize = ScreenAtom.use(undefined);
  var minCount = Caml.caml_int_min(Caml.caml_int_max(totGames / 50 | 0, 3), 10);
  var minPlace = Caml_splice_call.spliceApply(Math.min, [Belt_Array.map(Belt_Array.keep(dowStats, (function (param) {
                    return param[0] >= minCount;
                  })), (function (prim) {
                return prim[1];
              }))]);
  var maxPlace = Caml_splice_call.spliceApply(Math.max, [Belt_Array.map(Belt_Array.keep(dowStats, (function (param) {
                    return param[0] >= minCount;
                  })), (function (prim) {
                return prim[1];
              }))]);
  var match = React.useState(function () {
        
      });
  var setHoverIdx = match[1];
  var hoverIdx = match[0];
  var xScale = Scale.scaleLinear({
        domain: [
          0.5,
          7.5
        ],
        range: [
          0,
          Global.f(200)
        ]
      });
  var xScaleRev = Scale.scaleLinear({
        domain: [
          0,
          Global.f(200)
        ],
        range: [
          0.5,
          7.5
        ]
      });
  var yScale = Scale.scaleLinear({
        domain: [
          minPlace,
          maxPlace + (maxPlace - minPlace) / 10
        ],
        range: [
          0,
          Global.f(200)
        ]
      });
  var tmp;
  if (hoverIdx !== undefined) {
    var match$1 = Belt_Array.getExn(dowStats, hoverIdx);
    var count = match$1[0];
    tmp = React.createElement("div", {
          className: "absolute top-0 px-3 py-2 bg-bg0 rounded text-sm",
          style: Global.s({
                left: Global.toFixed(undefined, Caml.caml_float_min(140, 10 + Curry._1(xScale, Global.f(hoverIdx)))) + "px"
              })
        }, React.createElement("div", undefined, "Games: " + String(count)), React.createElement("div", undefined, "Place: " + (
              count === 0 ? "" : Global.toFixed(undefined, match$1[1])
            )));
  } else {
    tmp = null;
  }
  return React.createElement("div", {
              className: "flex flex-col items-center"
            }, React.createElement("div", undefined, "Placement by day of the week"), React.createElement("div", {
                  className: "relative pr-2"
                }, React.createElement("svg", {
                      height: "240",
                      width: "235",
                      onMouseLeave: (function (param) {
                          return Curry._1(setHoverIdx, (function (param) {
                                        
                                      }));
                        }),
                      onMouseMove: (function (e) {
                          var left = e.nativeEvent.offsetX - 35 | 0;
                          var idx = Caml.caml_int_min(Caml.caml_int_max(Math.round(Curry._1(xScaleRev, Global.f(left))) | 0, 0), dowStats.length);
                          if (idx > 0) {
                            return Curry._1(setHoverIdx, (function (param) {
                                          return idx - 1 | 0;
                                        }));
                          }
                          
                        })
                    }, React.createElement("g", {
                          transform: "translate(35, 10)"
                        }, React.createElement(Grid.Grid, {
                              top: 0,
                              left: 0,
                              xScale: xScale,
                              yScale: yScale,
                              stroke: "rgba(255, 255, 255, 0.24)",
                              width: 300,
                              height: 200,
                              numTicksRows: 5,
                              numTicksColumns: 8
                            }), React.createElement(Axis.AxisLeft, {
                              top: 0,
                              left: 0,
                              scale: yScale,
                              numTicks: 5,
                              stroke: "white",
                              tickStroke: "white",
                              tickLabelProps: (function (param) {
                                  return LpChartUtils.tickLabelPropsLeftBase(screenSize, param);
                                })
                            }), React.createElement(Axis.AxisBottom, {
                              top: 200,
                              left: 0,
                              scale: xScale,
                              numTicks: 8,
                              stroke: "white",
                              tickValues: Belt_Array.map(Belt_Array.range(1, 7), Global.f),
                              tickStroke: "white",
                              tickFormat: (function (v) {
                                  if (v < 4) {
                                    if (v !== 1) {
                                      if (v !== 2) {
                                        if (v !== 3) {
                                          return Global.toFixed(undefined, v);
                                        } else {
                                          return "Wed";
                                        }
                                      } else {
                                        return "Tue";
                                      }
                                    } else {
                                      return "Mon";
                                    }
                                  } else if (v < 6) {
                                    if (v !== 4) {
                                      if (v !== 5) {
                                        return Global.toFixed(undefined, v);
                                      } else {
                                        return "Fri";
                                      }
                                    } else {
                                      return "Thu";
                                    }
                                  } else if (v !== 6) {
                                    if (v !== 7) {
                                      return Global.toFixed(undefined, v);
                                    } else {
                                      return "Sun";
                                    }
                                  } else {
                                    return "Sat";
                                  }
                                }),
                              tickLabelProps: (function (param) {
                                  return LpChartUtils.tickLabelPropsBottom(screenSize, param);
                                })
                            }), Belt_Array.mapWithIndex(dowStats, (function (idx, param) {
                                if (param[0] < minCount) {
                                  return React.createElement("g", undefined);
                                }
                                var place = param[1];
                                return React.createElement("rect", {
                                            key: String(idx),
                                            height: Global.toFixed(undefined, 200 - Curry._1(yScale, place)),
                                            width: "16",
                                            fill: Caml_obj.caml_equal(hoverIdx, idx) ? "var(--secondary-9)" : "var(--primary-10)",
                                            x: Global.toFixed(undefined, Curry._1(xScale, Global.f(idx + 1 | 0)) - 8),
                                            y: Global.toFixed(undefined, Curry._1(yScale, place))
                                          });
                              })))), tmp), React.createElement("div", {
                  className: "text-sm text-white2"
                }, Region.toName3(region) + " server timezone"));
}

var DowStats = {
  make: WrappedTimeStats$DowStats
};

function WrappedTimeStats(Props) {
  var hourStats = Props.hourStats;
  var dowStats = Props.dowStats;
  var totGames = Props.totGames;
  var region = Props.region;
  return React.createElement("div", {
              className: "mt-16"
            }, React.createElement(WrappedSectionHeader.make, {
                  title: "When are you at your best?"
                }), React.createElement("div", {
                  className: "flex justify-between"
                }, React.createElement(WrappedTimeStats$HourStats, {
                      hourStats: hourStats,
                      totGames: totGames
                    }), React.createElement(WrappedTimeStats$DowStats, {
                      dowStats: dowStats,
                      totGames: totGames,
                      region: region
                    })));
}

var make = WrappedTimeStats;

export {
  HourStats ,
  DowStats ,
  make ,
  
}
/* react Not a pure module */
